<slotcom-navigation-button
  type="close"
  (click)="closeModal()"></slotcom-navigation-button>

<div class="info-background">
  <slotcom-p
    class="info-title"
    [bold]="true"
    [text]="'home.live-ops.tournaments.modal-info.title' | translate"
    [shadowBorder]="true"></slotcom-p>

  <div class="info-steps-container">
    <div
      class="info-step-1-spark"
      theming
      themingGroup="tournament"
      themingAsset="info-spark"
      [themingOverride]="tournamentInfoModalData?.data?.assets">
      @if (gameId) {
        <ng-container *ngTemplateOutlet="specificStep; context: { textStep: '1-specific', imgStep: '1' }">
        </ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="infoStep; context: { textStep: '1', imgStep: '1' }"> </ng-container>
      }
    </div>

    <div
      theming
      themingGroup="tournament"
      themingAsset="arrow"
      [themingOverride]="tournamentInfoModalData?.data?.assets"
      class="arrow-image"></div>

    <ng-container *ngTemplateOutlet="infoStep; context: { textStep: '2', imgStep: '2' }"> </ng-container>

    <div
      theming
      themingGroup="tournament"
      themingAsset="arrow"
      [themingOverride]="tournamentInfoModalData?.data?.assets"
      class="arrow-image"></div>

    <ng-container *ngTemplateOutlet="infoStep; context: { textStep: '3', imgStep: '3' }"> </ng-container>
  </div>

  <ng-template
    #infoStep
    let-textStep="textStep"
    let-imgStep="imgStep">
    <div class="info-step">
      <div
        [class]="['step-image', 'step-image-' + textStep]"
        data-testid="slotcom-tournament-information-step"
        theming
        themingGroup="tournament"
        [themingAsset]="'step-' + imgStep"
        [themingOverride]="tournamentInfoModalData?.data?.assets"></div>
      <slotcom-p
        class="step-text"
        [bold]="true"
        [text]="'home.live-ops.tournaments.modal-info.step-' + textStep | translate"
        [shadowBorder]="true"></slotcom-p>
    </div>
  </ng-template>

  <ng-template
    #specificStep
    let-textStep="textStep"
    let-imgStep="imgStep">
    <div class="info-step">
      <div
        [class]="['step-image', 'step-image-' + textStep]"
        data-testid="slotcom-tournament-information-step"
        [ngStyle]="gameIcon"></div>
      <slotcom-p
        class="step-text"
        [bold]="true"
        [text]="'home.live-ops.tournaments.modal-info.step-' + textStep | translate: { x: gameName | uppercase }"
        [shadowBorder]="true"></slotcom-p>
    </div>
  </ng-template>
</div>
